export const BLOB_CONFIG = {
  "background": "#ffffff",
  "gradientMap": "21",
  "gradientColor1": "#ffb3ba",
  "gradientColor2": "#bae1ff",
  "gradientColor3": "#b8e6b8",
  "uPositionFrequency": 1.57,
  "uPositionStrength": 1.29,
  "uSmallWavePositionFrequency": 0.46,
  "uSmallWavePositionStrength": 1.11,
  "uSmallWaveTimeFrequency": 0,
  "uTimeFrequency": 0.15,
  "roughness": 0.8300000000000001,
  "metalness": 0.12,
  "envMapIntensity": 3.85,
  "clearcoat": 0.47000000000000003,
  "clearcoatRoughness": 0.14,
  "transmission": 0.3,
  "wireframe": false,
  "flatShading": false,
  "autoRotate": true,
  "autoRotateSpeed": 2.5
}